import { useCallback, useEffect, useRef } from 'react';
const FOCUS_SELECTOR = 'a, input, select, textarea, button, object, [tabindex]:not([tabindex="-1"])';
function findTabbableElements(container) {
    return Array.from(container.querySelectorAll(FOCUS_SELECTOR)).filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);
}
function trapFocus(container, event) {
    const tabbableElements = findTabbableElements(container);
    if (tabbableElements.length === 0) {
        event.preventDefault();
        return;
    }
    const firstElement = tabbableElements[0];
    const lastElement = tabbableElements[tabbableElements.length - 1];
    if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
    }
    else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
    }
}
function focusNode(container) {
    const tabbableElements = findTabbableElements(container);
    const focusElement = tabbableElements[0] || container;
    if (focusElement) {
        focusElement.focus({ preventScroll: true });
    }
    else {
        console.warn('No focusable elements found in the container.');
    }
}
export function useFocusTrap(active = true) {
    const containerRef = useRef(null);
    const setRef = useCallback((node) => {
        if (node === null || containerRef.current === node) {
            return;
        }
        containerRef.current = node;
        // delay focus assignment until DOM is stable
        setTimeout(() => {
            if (node?.getRootNode()) {
                focusNode(node);
            }
            else {
                console.warn('Ref node is not part of the DOM:', node);
            }
        });
    }, []);
    useEffect(() => {
        if (!active || !containerRef.current) {
            return;
        }
        const handleKeyDown = (event) => {
            if (event.key === 'Tab') {
                trapFocus(containerRef.current, event);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [active]);
    return setRef;
}
//# sourceMappingURL=useFocusTrap.js.map